import React, { useState } from "react"

import SEO from "@components/seo"
import Container from "@components/container"
import Button from "@components/button"
import Section from "@components/section"
import EventTime from "@components/eventTime"
import GameTabs from "@components/gameTabs"
import Sfv from "@components/pages/2021/season1/sfv"
import SuperSmashBros from "@components/pages/2021/season1/superSmashBros"

// import mk8Logo from "@images/mk8.png"
import sfvLogo from "@images/sfv.png"
import superSmashBrosLogo from "@images/ssb.png"
import mapImage from "@images/2021/season1/map.png"

const Season1 = () => {
  const [en, setEn] = useState(false)

  const common = (
    <Section title={en ? "Venue Address" : "比赛地点"}>
      <a href="https://j.map.baidu.com/2e/Xj" target="_blank" className="map">
        <img src={mapImage} />
        <p className="text-center">
          {en
            ? "Beijing Etrong International Exhibition & Convention Center"
            : "北京亦创国际会展中心 "}
        </p>
      </a>
    </Section>
  )

  const langSwitch = (
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      <Button
        color={"blue"}
        onClick={() => {
          setEn(en => !en)
        }}
      >
        {en ? "查看中文版" : "English"}
      </Button>
    </div>
  )

  return (
    <>
      <SEO title="SEASON 1" />
      <EventTime enroll="4.15 ~ 4.30" start="5.1 ~ 5.16" />
      <Container>
        <GameTabs
          games={[
            {
              key: "superSmashBros",
              title: "任天堂明星大乱斗 特别版",
              logo: superSmashBrosLogo,
            },
            { key: "sfv", title: "街头霸王5 冠军版", logo: sfvLogo },
          ]}
        >
          {key => {
            let page
            if (key === "sfv") {
              page = <Sfv en={en} />
            } else if (key === "superSmashBros") {
              page = <SuperSmashBros en={en} />
            }
            return (
              <>
                {langSwitch}
                {common}
                {page}
              </>
            )
          }}
        </GameTabs>
      </Container>
    </>
  )
}

export default Season1
